export default {"src":"/_next/static/media/flag-turkiye.073599a9.svg","height":12,"width":18,"blurWidth":0,"blurHeight":0};